import React from 'react'
import { connect } from 'react-redux'

import { Container, Header, Table } from 'semantic-ui-react'

import DocumentManager from '../components/DocumentManager'

function Downloads({ config }) {
	
	const downloads = config.downloads;
	
	return (
		<>
			<Container text style={{ color: '#fff', flex: 1, padding: '2em 0' }}>
				
				<Header as='h1' inverted style={{ marginBottom: '1em' }}>Downloads</Header>
				
				<Table celled>
					<Table.Body>
					{Object.keys(downloads).map((key) =>
						<Table.Row key={ key }>
							<Table.Cell>
								{ downloads[key].name }
							</Table.Cell>
							<Table.Cell>
								<DocumentManager
									name={downloads[key].name}
									type='download'
									color='red'
								/>
								<DocumentManager
									name={downloads[key].name}
									type='print'
									color='red'
								/>
							</Table.Cell>
						</Table.Row>
					)}
					</Table.Body>
				</Table>
				
			</Container>
		</>
	)
}

const mapStateToProps = state => ({
	config: state.config.config
})

export default connect(
	mapStateToProps,
	null
)(Downloads)
